import type { AliasTokens, OpacityScale, SemanticInteraction } from '@/theme/types'

export const createSemanticInteraction = (
  alias: AliasTokens,
  opacity: OpacityScale,
  mode: 'light' | 'dark' = 'light',
): SemanticInteraction => {
  // Hover/active/focus colors depend on theme
  // In dark theme: use lighter overlay on dark surface
  // In light theme: use darker overlay on light surface
  const hoverColor = mode === 'dark' 
    ? `rgba(255, 255, 255, ${opacity.hover})` 
    : `rgba(0, 0, 0, ${opacity.hover})`
  
  const activeColor = mode === 'dark'
    ? `rgba(255, 255, 255, ${opacity.focus})`
    : `rgba(0, 0, 0, ${opacity.focus})`
  
  const focusColor = mode === 'dark'
    ? `rgba(255, 255, 255, ${opacity.focus})`
    : `rgba(0, 0, 0, ${opacity.focus})`
  
  const disabledColor = mode === 'dark'
    ? `rgba(255, 255, 255, ${opacity.disabled})`
    : `rgba(0, 0, 0, ${opacity.disabled})`

  return {
    hover: hoverColor,
    active: activeColor,
    focus: focusColor,
    disabled: disabledColor,
    selected: alias.brandPrimarySoft,
    pressed: alias.brandPrimary,
    focusRing: alias.brandPrimary,
    outline: alias.brandBorder,
    selection: alias.brandPrimarySoft,
  }
}

